import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { ScrollComponent } from '../../../common/scrollComponent'
import { selectProfileIds } from '../store/slice'
import { getAlertSettingsDynamic, getProfileDetail } from '../store/thunk'
import { EnableEmail } from './EnableEmail'
import { ApplyPortfolios } from './applyPortfolios'
import { ButtonGroup } from './buttonGroup'
import { CREATE_EDIT_PROFILE_SCROLL_ID } from './constant'
import { CreateType } from './createType'
import { EventRules } from './eventRules'
import { FinancialRules } from './financialRules'
import classes from './index.module.scss'
import { ProfileName } from './profileName'
import { ScoreRules } from './scoreRules'
import { selectLoading, selectOtherSetting } from './store/slice'
import { getProfileDefault } from './store/thunk'
import { TrackCompanylRules } from './trackCompanyRules'

export const CreateEditProfile = ({ createMode, onCancel, onSave }) => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  const detailProfileId = searchParams.get('profileId')
  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectLoading('getProfileDetail'))
  const idsTable = useSelector(selectProfileIds)
  const isFollowingList = useSelector(selectOtherSetting('isFollowingList'))

  useEffect(() => {
    if (detailProfileId) {
      dispatch(
        getProfileDetail({
          AlertProfileId: detailProfileId,
        }),
      )
    }

    if (!idsTable.length) {
      dispatch(getAlertSettingsDynamic())
    }
  }, [detailProfileId, locale])

  useEffect(() => {
    return () => dispatch(getProfileDefault())
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <div className="h100 flexColumn">
      <div id={CREATE_EDIT_PROFILE_SCROLL_ID} className="flex1 minH0">
        <ScrollComponent
          autoHeight={!createMode}
          autoHeightMax={createMode ? undefined : 100000}
        >
          <div className="px1 pt1">
            <div className="dFlex alignItemsStretch gap2">
              <ProfileName
                createMode={createMode}
                isFollowingList={isFollowingList}
              />

              {createMode && (
                <Element
                  className={classes.divider}
                  style={{ backgroundColor: '#D5D5D5' }}
                />
              )}

              <EnableEmail />
            </div>

            {createMode && <CreateType />}

            <div className={classes.panels}>
              {!createMode && isFollowingList ? (
                <TrackCompanylRules />
              ) : (
                <>
                  <EventRules isCreate={createMode} />
                  <ScoreRules isCreate={createMode} />
                  <FinancialRules isCreate={createMode} />
                  <ApplyPortfolios />
                </>
              )}
            </div>
          </div>
        </ScrollComponent>
      </div>

      <ButtonGroup
        createMode={createMode}
        onCancel={onCancel}
        onSave={onSave}
      />
    </div>
  )
}

CreateEditProfile.propTypes = {
  createMode: PropTypes.bool,
  defaultSettings: PropTypes.object,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
}

CreateEditProfile.defaultProps = {
  createMode: false,
}
